import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconTick, IconX } from '../../1-foundation/icons/icons';
import Cta from '../../2-atoms/cta/cta';

const SkyItFeatureList = ({ title, items, cta }) => {
  return (
    <div className="c-sky-it-feature-list">
      <div className="c-sky-it-feature-list__title" dangerouslySetInnerHTML={{ __html: title }} />
      <ul className="c-sky-it-feature-list__list">
        {items.map((item, key) => (
          <li key={key} className="c-sky-it-feature-list__item" disabled={item.disabled}>
            {item.disabled ? <IconX /> : <IconTick />}
            <span>{item.text}</span>
          </li>
        ))}
      </ul>
      {cta && (
        <div className="c-sky-it-feature-list__cta">
          <Cta href={cta.href} target={cta.target} modifiers={cta.modifiers} append={cta.append} onClick={cta.onClick}>
            {cta.text}
          </Cta>
        </div>
      )}
    </div>
  );
};

SkyItFeatureList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      text: PropTypes.string.isRequired,
    })
  ),
  cta: PropTypes.object,
};

export default SkyItFeatureList;
